import axios from 'axios';

const API_BASE = process.env.REACT_APP_API_URL || '/api';

export type ScheduledJobState = 'NEVER_RUN' | 'RUNNING' | 'SUCCEEDED' | 'FAILED';

export interface ScheduledJobStatus {
  name: string;
  schedule: string;
  state: ScheduledJobState;
  lastStartedAt: string | null;
  lastFinishedAt: string | null;
  lastDurationMs: number | null;
  lastError: string | null;
  runCount: number;
  failureCount: number;
}

export const getScheduledJobs = async (token: string): Promise<ScheduledJobStatus[]> => {
  const res = await axios.get(`${API_BASE}/admin/scheduled-jobs`, {
    headers: { Authorization: `Bearer ${token}` },
    withCredentials: true,
  });
  return res.data;
};
